import { Component, Input, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { BcAnalytics } from 'common/analytics/analytics.service';

@Component({
  selector: 'text-chat-buttons',
  templateUrl: './text-chat-buttons.component.html',
  encapsulation: ViewEncapsulation.None
})

export class TextChatButtonsComponent {
  @Output() transfer: EventEmitter<any> = new EventEmitter<any>();

  @Output() wrapup: EventEmitter<any> = new EventEmitter<any>();

  @Input() isEndable: boolean;

  @Input() hasWrapUps: boolean;

  @Output() end: EventEmitter<any> = new EventEmitter<any>();

  constructor(private bcAnalytics: BcAnalytics) {
  }

  endTextChatClick() {
    this.end.emit();
    this.bcAnalytics.eventTrack('EndTextChatButton');
  }

  transferButtonClick() {
    this.transfer.emit();
    this.bcAnalytics.eventTrack('TextChatTransferButton');
  }

  wrapupButtonClick() {
    this.wrapup.emit();
    this.bcAnalytics.eventTrack('TextChatWrapupButton');
  }
}

